import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import ExportEmployeesModal from 'modules/employees/components/ExportEmployeesModal'
import { useOnCloseGoToList } from 'modules/employees/hooks/useOnCloseGoList'

const ExportEmployeesModalPage = () => {
  const onClose = useOnCloseGoToList()

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return (
    <ExportEmployeesModal onClose={onClose} contractVersions={contractVersions} loading={loading} />
  )
}

export default ExportEmployeesModalPage
